import { Component } from '@angular/core';

@Component({
    selector: 'return-assets',
    templateUrl: './returnAssets.component.html',
    styleUrls: ['./returnAssets.component.scss'],
    standalone: false
})
export class ReturnAssetsComponent {
}
